// @flow
import React from "react";
import { connect } from "react-redux";

import { withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelecaoRadioBase from "./SelecaoRadioBase";
import { type ActionCreator, selecionarPeriodo } from "../../state";
import { type Id } from "../../model";

type Props = {
  nomeSelecao: string,
  listaItens: Array<any>,
  itemSelecionado: Id,
  selecionarItem: ActionCreator,
  campoId: string,
  disabled: boolean,
  radioName: string,
};

function SelecaoRadioBaseComTraducao({
  nomeSelecao,
  listaItens,
  itemSelecionado,
  selecionarItem,
  campoId = "id",
  radioName,
  disabled = false,
}: Props) {
  return (
    <SelecaoRadioBase
      nomeSelecao={nomeSelecao}
      listaItens={listaItens}
      itemSelecionado={itemSelecionado}
      onChange={id => selecionarItem(id)}
      campoId={campoId}
      campoDescricao={"traducao"}
      radioName={radioName}
      disabled={disabled}
    />
  );
}

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaItens: ownProps.itensSelector(state).map(item => ({
        ...item,
        traducao: ownProps.translate(item[ownProps.campoChaveTraducao]),
      })),
      itemSelecionado: ownProps.selectorItemSelecionado(state),
      nomeSelecao:
        ownProps.translate(ownProps.chaveTraducaoNomeSelecao) ||
        ownProps.chaveTraducaoNomeSelecao,
    }),
    (dispatch, ownProps) => ({
      selecionarItem: id => {
        if (
          ownProps.periodos &&
          ownProps.periodoId &&
          ownProps.periodoDefault
        ) {
          switch (id) {
            case 1:
              if (!ownProps.periodos.includes(ownProps.periodoId[0]))
                dispatch(selecionarPeriodo([ownProps.periodoDefault]));
              break;
            case 2:
              dispatch(selecionarPeriodo([ownProps.periodoDefault]));
              break;
            default:
          }
        }

        dispatch(ownProps.onItemChange(id));
      },
    })
  )
)(SelecaoRadioBaseComTraducao);
